<template>
  <div class="dialog_box">
    <el-dialog title="权限配置" :visible="show" width="878px" @close="dialogClose" top="10vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <div class="permission_box">
          <div class="tree">
            <div class="tree_title">所有菜单</div>
            <el-tree :data="roleList" show-checkbox ref="tree" node-key="id" :props="defaultProps"
              :default-checked-keys="autIdList" @check="check" :default-expand-all="true">
              <!-- :default-expanded-keys="autIdList" -->
            </el-tree>
          </div>

          <div class="tree">
            <div class="tree_title">授权菜单</div>
            <ul>
              <li v-for="(item, index) in autMenuList" :key="index">
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="tree">
            <div class="tree_title">授权功能</div>
            <ul>
              <li v-for="(item, index) in autOperateList" :key="index">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      form: {},
      imgUrl: "",
      stateList: [],
      rules: {},
      radio: "1",
      roleList: [],
      autIdList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      autMenuList: [], // 授权菜单
      autOperateList: [], // 授权功能
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  watch: {
    show (val) {
      if (val) {
        this.autIdList = [];
        this.$http
          .queryRoleMenuPerm({ roleId: this.data.roleId })
          .then((res) => {
            if (res.code == 0) {
              let authList = res.data;
              this.$http.getMenutree({ isTree: true }).then((treeRes) => {
                if (treeRes.code === 0) {
                  authList.forEach((a) => {
                    treeRes.data.forEach((b) => {
                      if (a === b.id) {
                        b.isSelect = true;
                      }
                      if (b.children) {
                        b.children.forEach((c) => {
                          if (a === c.id) {
                            c.isSelect = true;
                          } else {
                            b.isSelect = false;
                          }
                        });
                      }
                    });
                  });
                  this.roleList = treeRes.data;
                  this.roleList.forEach((i) => {
                    if (i.isSelect) {
                      this.autMenuList.push(i);
                      if (i.children && i.children.length > 0) {
                        console.log(111);
                        i.children.forEach((j) => {
                          if (j.type == "B") {
                            this.autOperateList.push(...i.children);
                          }
                          if (j.type == "C") {
                            this.autMenuList.push(j);
                          }
                          if (j.children) {
                            if (j.children[0].type == "B") {
                              this.autOperateList.push(...j.children);
                            }
                          }
                          if (j.isSelect) {
                            this.autIdList.push(j.id);
                          }
                        });
                      }
                      this.autIdList.push(i.id);
                    } else {
                      if (i.children && i.children.length > 0) {
                        i.children.forEach((k) => {
                          if (k.type == "C" && k.isSelect) {
                            this.autMenuList.push(k);
                            if (i.id === k.parentId) {
                              this.autMenuList.push(i);
                              // 如果
                              this.autMenuList = [...new Set(this.autMenuList)];
                            }
                          }
                          if (k.children) {
                            if (k.children[0].type == "B") {
                              this.autOperateList.push(...k.children);
                            }
                          }
                          if (k.isSelect) {
                            this.autIdList.push(k.id);
                          }
                        });
                      }
                    }
                  });
                  this.autMenuList = this.autMenuList.sort((a, b) => {
                    return a.id - b.id;
                  });
                }
              });
            } else {
              this.roleList = [];
            }
          });
      }
    },
  },
  created () { },
  methods: {
    confirm () {
      let menuList = [];
      this.autMenuList.forEach((i) => {
        menuList.push(i.id);
      });
      this.autOperateList.forEach((i) => {
        menuList.push(i.id);
      });
      let params = {
        menuList,
        roleId: this.data.roleId,
      };
      this.$http.roleMenuPerm(params).then((res) => {
        if (res.code === 0) {
          this.$message.success(res.msg);
          this.autIdList = [];
          this.$emit("update:show", false);
        } else {
          this.$message.info(res.msg);
        }
      });
    },
    check (data, treeData) {
      this.autMenuList = [];
      this.autOperateList = [];
      let treeArr = treeData.checkedNodes;
      let notAll = treeData.halfCheckedNodes;
      treeArr = treeArr.concat(notAll);
      treeArr.forEach((a) => {
        if (a.type == "M" || a.type == "C") {
          this.autMenuList.push(a);
        } else if (a.type == "B") {
          this.autOperateList.push(a);
        }
      });
      this.autMenuList = this.autMenuList.sort((a, b) => {
        return a.id - b.id;
      });
      this.autOperateList = this.autOperateList.sort((a, b) => {
        return a.id - b.id;
      });
    },
    handleNodeClick (data) {
      console.log(data);
    },
    dialogClose () {
      this.autMenuList = [];
      this.autOperateList = [];
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-form-item__content {
  width: 240px;
}

.permission_box {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  min-height: 588px;

  .tree {
    width: 188px;
    border: 1px solid #b4bbc5;
    box-sizing: border-box;

    .tree_title {
      width: 100%;
      height: 25px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      font-weight: 500;
      color: #000000;
      border-bottom: 1px solid #b4bbc5;
    }
  }
}

/deep/.el-tree-node {
  .el-tree-node__content {
    height: 40px;
  }
}

/deep/.el-dialog__body {
  max-height: 70vh;
  overflow-y: scroll;
}

ul {
  list-style: none;
  line-height: 40px;
  margin: 0 0 0 24px;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/approve_Admin/approve_Flow.vue